var _rect, _path, _path2, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5016 13.9393C27.6969 14.1346 27.6969 14.4512 27.5016 14.6464L26.4587 15.6893L24.4587 13.6893L25.5016 12.6464C25.6969 12.4512 26.0134 12.4512 26.2087 12.6464L27.5016 13.9393Z",
    fill: "#0923E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7516 16.3964L23.7516 14.3964L16.9386 21.2094C16.8837 21.2643 16.8424 21.3312 16.8178 21.4049L16.0133 23.8186C15.9481 24.014 16.134 24.1999 16.3295 24.1348L18.7432 23.3302C18.8168 23.3057 18.8837 23.2643 18.9386 23.2094L25.7516 16.3964Z",
    fill: "#0923E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 25.5C13 26.3284 13.6716 27 14.5 27H25.5C26.3284 27 27 26.3284 27 25.5V19.5C27 19.2239 26.7761 19 26.5 19C26.2239 19 26 19.2239 26 19.5V25.5C26 25.7761 25.7761 26 25.5 26H14.5C14.2239 26 14 25.7761 14 25.5V14.5C14 14.2239 14.2239 14 14.5 14H21C21.2761 14 21.5 13.7761 21.5 13.5C21.5 13.2239 21.2761 13 21 13H14.5C13.6716 13 13 13.6716 13 14.5V25.5Z",
    fill: "#0923E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 3.5,
    stroke: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBorder);
export default __webpack_public_path__ + "static/media/editBorder.5af50a421730f591f396a612aa215cc1.svg";
export { ForwardRef as ReactComponent };